import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CARRIER_SIZES } from '@/lib/constants';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownCarrierSize: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();

  const carrierSize = CARRIER_SIZES.map((item) => ({
    ...item,
    text: t(`label.carrierSizes.${item.value}`),
  }));

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.carrierSize')}
      data={carrierSize}
      control="checkbox"
      search
    />
  );
};
